import type { CityConfig } from "../city-template/types";

export const lafayetteInConfig: CityConfig = {
  city: "Lafayette",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "lafayette-in",
  route: "/lafayette-in",
  title: "Emergency Passport Lafayette, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Lafayette, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Lafayette, West Lafayette, Purdue University, Frankfort, Crawfordsville, and all Tippecanoe County residents. A+ BBB rated registered courier.",
  h1: "Emergency & Expedited Passport Services in Lafayette, IN",
  heroSubtitle: "Lafayette and West Lafayette travelers — from Purdue University students and faculty heading abroad to Tippecanoe County families planning international vacations to business travelers in the Wabash Valley — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just over an hour south via I-65.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lafayette%20Indiana%20and%20West%20Lafayette%20cityscape%20across%20the%20Wabash%20River%20with%20Purdue%20University%20campus%20buildings%20and%20bell%20tower%20visible%2C%20historic%20downtown%20Lafayette%20with%20vibrant%20Main%20Street%20and%20John%20T%20Myers%20pedestrian%20bridge%20connecting%20both%20cities%2C%20tree%20lined%20streets%20in%20a%20classic%20Midwest%20college%20town%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20urban%20photography%20with%20rich%20warm%20academic%20tones%2C%20classic%20Big%20Ten%20university%20town%20charm%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=lafayette-in-hero-001&orientation=landscape",
  heroImageAlt: "Lafayette Indiana and West Lafayette skyline with Purdue University campus and Wabash River",
  geoPosition: "40.4167;-86.8753",
  geoPlacename: "Lafayette, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 2 hours northwest via I-65 — about 120 miles",
  },
  nearbyCitiesZips: [
    { name: "Lafayette", zips: "47901, 47904, 47905" },
    { name: "West Lafayette", zips: "47906, 47907" },
    { name: "Frankfort", zips: "46041" },
    { name: "Crawfordsville", zips: "47933" },
    { name: "Delphi", zips: "46923" },
    { name: "Attica", zips: "47918" },
    { name: "Dayton", zips: "47941" },
    { name: "Battle Ground", zips: "47920" },
    { name: "Brookston", zips: "47923" },
    { name: "Tippecanoe County rural area", zips: "47901, 47905, 47909" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — about 1 hour from Lafayette via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Tippecanoe County" },
    { icon: "ri-building-line", title: "Purdue University Hub", desc: "Serving Purdue students, faculty, staff, international researchers, and Tippecanoe County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx near Purdue campus or downtown Lafayette" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/indianapolis" },
    { name: "Emergency passport help in Indianapolis, IN", route: "/indianapolis" },
    { name: "Urgent passport services in Carmel, IN", route: "/carmel" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Lafayette and West Lafayette, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 120 miles — about 2 hours via I-65. We handle the drive so Purdue students, faculty, and Tippecanoe County families never need to navigate Chicago traffic.",
  fpcOfficeDistance: "Serving Lafayette, West Lafayette, Purdue University, Frankfort, Crawfordsville, Delphi, Attica, and all of Tippecanoe County and the surrounding Wabash Valley region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Lafayette, West Lafayette, and Tippecanoe County. From the Purdue University campus and Chauncey Hill to downtown Lafayette and the Wabash River communities — we serve all of Tippecanoe County and the Wabash Valley.",
  nearbyCitiesIntro: "We serve Lafayette and all nearby communities including West Lafayette (Purdue University), Frankfort, Crawfordsville, Delphi, Attica, and Battle Ground. We also serve all of Tippecanoe County and the Purdue community.",
  howItWorksIntro: "Most Lafayette travelers — especially Purdue students preparing for study abroad and faculty traveling for research — complete everything online and ship documents via overnight courier from any UPS or FedEx near campus or downtown. Our registered couriers handle the Chicago Passport Agency delivery.",
  mistakesIntro: "Lafayette and West Lafayette are home to Purdue University — one of the largest international student and faculty populations in Indiana. Here are the most common passport mistakes we see from Tippecanoe County travelers.",
  testimonialsIntro: "Lafayette travelers — from Purdue students heading to study abroad to faculty traveling for research to Tippecanoe County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Lafayette and West Lafayette, IN? Here are the most common ones we hear from Purdue and Tippecanoe County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Indianapolis drive required — ship from Lafayette or Purdue campus", "Perfect for Purdue study abroad, faculty research trips, and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned study abroad and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~1 hour each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lafayette and Purdue travelers with immediate departure needs — as fast as 24 hours. Ideal for Purdue students with last-minute study abroad deadlines, faculty with unexpected research travel, or Tippecanoe County families with urgent trips.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 1-hour drive", "Purdue student and faculty travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Lafayette and West Lafayette adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Purdue faculty and Tippecanoe County professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Lafayette or West Lafayette address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Purdue students, Tippecanoe County residents, and new citizens in the Lafayette area.",
      bullets: ["Acceptance facility scheduling near Purdue campus or downtown", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Lafayette and West Lafayette residents — whether lost on Purdue campus, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Lafayette and Tippecanoe County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Lafayette and Tippecanoe County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Lafayette IN", description: "Urgent passport processing for Lafayette and West Lafayette Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Lafayette IN", description: "Fast passport renewal for Lafayette Indiana residents and Purdue University students." },
    { name: "First-Time Passport Lafayette IN", description: "New passport application services for Lafayette Indiana residents and Purdue students." },
    { name: "Child Passport Lafayette IN", description: "Minor passport services for Lafayette Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Priya S.",
      location: "West Lafayette, IN — Purdue University",
      rating: 5,
      text: "Got accepted into a summer research program in Germany with 10 days before departure. My passport had expired over winter break. Fast Passport Center renewed it in 3 days. Shipped from the UPS Store on Northwestern Avenue near campus. Made my flight without a single issue.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Professor David K.",
      location: "Lafayette, IN — Near Downtown",
      rating: 5,
      text: "Keynote speaker at a conference in Singapore with 12 days notice. My passport was valid but had less than 4 months remaining. Fast Passport Center expedited my renewal and I had it in 4 days. Outstanding service for academic travelers.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Emily & James R.",
      location: "West Lafayette, IN — Purdue Family Housing",
      rating: 5,
      text: "Post-doc position in the Netherlands starting in 3 weeks and our baby needed a first-time passport. The West Lafayette Post Office was booked solid. Fast Passport Center walked us through the infant passport process and we had it in 5 days. Made our move on schedule.",
      service: "Infant First-Time Passport",
    },
    {
      name: "Alex M.",
      location: "Lafayette, IN — Wabash Valley",
      rating: 5,
      text: "Lost my passport somewhere between spring break travel and coming back to Purdue. Had a study abroad departure for Spain in 8 days. Fast Passport Center replaced it in 48 hours. The courier to Indianapolis saved my semester abroad.",
      service: "Lost Passport Emergency",
    },
  ],
  facilities: [
    {
      id: "lafayette-in-1",
      name: "Lafayette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3450 State Road 26 E",
      city: "Lafayette",
      state: "IN",
      zip: "47905",
      phone: "(765) 447-6944",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Lafayette, near Tippecanoe Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lafayette acceptance facility. Appointments required — book 3–4 weeks ahead during Purdue study abroad season (September–November and February–April). Extremely busy during peak Purdue travel windows.",
      icon: "ri-mail-line",
    },
    {
      id: "lafayette-in-2",
      name: "West Lafayette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Chauncey Ave",
      city: "West Lafayette",
      state: "IN",
      zip: "47906",
      phone: "(765) 743-2573",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown West Lafayette, near Purdue University campus and Chauncey Hill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Most convenient acceptance facility for Purdue students and West Lafayette residents. Extremely busy during study abroad season — appointments fill 4–6 weeks in advance. Walk-ins not accepted.",
      icon: "ri-mail-line",
    },
    {
      id: "lafayette-in-3",
      name: "Tippecanoe County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "301 Main St",
      city: "Lafayette",
      state: "IN",
      zip: "47901",
      phone: "(765) 423-9326",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Downtown Lafayette, Tippecanoe County Courthouse",
      website: "https://www.tippecanoe.in.gov/",
      websiteLabel: "Tippecanoe County",
      notes: "County clerk passport acceptance. Extended morning hours. Good alternative when post office appointments are full during peak Purdue study abroad seasons.",
      icon: "ri-government-line",
    },
    {
      id: "lafayette-in-4",
      name: "Frankfort Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W Walnut St",
      city: "Frankfort",
      state: "IN",
      zip: "46041",
      phone: "(765) 654-5575",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 20 miles southeast of Lafayette, in Frankfort",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility southeast of Lafayette. Often has better appointment availability than Lafayette locations during Purdue peak seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "lafayette-in-5",
      name: "Crawfordsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E Main St",
      city: "Crawfordsville",
      state: "IN",
      zip: "47933",
      phone: "(765) 362-4231",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 30 miles south of Lafayette, in Crawfordsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility south of Lafayette. Convenient for Crawfordsville and Montgomery County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1+ hour drive to Indianapolis via I-65", fpc: "No — ship from Lafayette or Purdue campus, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Purdue Study Abroad Support", agency: "No special support for students", fpc: "Experienced with Purdue study abroad deadlines and requirements" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Study Abroad Acceptance",
      description: "Purdue students often discover passport issues only after being accepted into a study abroad program. Routine processing takes 8–11 weeks — far beyond most program departure windows. Check your passport as soon as you apply, not after acceptance.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Student photo services near Purdue campus sometimes produce photos that fail State Department standards. Photos must be exactly 2x2 inches on a white background — no filters, no smiling with teeth showing, no glasses. Photos from the Purdue ID office may not meet passport specs.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants — especially Purdue students applying for their first passport — often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 can be mailed for most renewals.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Purdue Academic Calendar",
      description: "Purdue study abroad deadlines typically cluster in October (for spring programs) and March (for fall/summer programs). West Lafayette Post Office appointments fill 4–6 weeks ahead during these periods. Book your acceptance facility visit as early as possible.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Purdue students heading to semester-long programs in Europe or Asia often discover this requirement too late — especially when programs span 4+ months.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Indianapolis Agency Is Close Enough for Walk-Ins",
      description: "The Chicago Passport Agency requires appointments booked through NPIC — no walk-ins. Even though it's about an hour away via I-65, you cannot simply show up. And appointments are not guaranteed, especially during peak travel seasons.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Lafayette, West Lafayette, or on Purdue campus." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store on Northwestern Avenue or any FedEx in Lafayette." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Tippecanoe County or Purdue documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 1-hour drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lafayette or West Lafayette address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Lafayette, IN?", a: "Fast Passport Center offers emergency passport processing in Lafayette and West Lafayette, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — about 63 miles south." },
    { q: "Does Lafayette have its own passport agency near Purdue?", a: "No — neither Lafayette nor West Lafayette has a regional passport agency. The nearest is the Chicago Passport Agency, approximately 63 miles south (about an hour and 10 minutes via I-65). Fast Passport Center's courier service means Purdue students and faculty never need to drive to Indianapolis themselves." },
    { q: "Can Purdue international students get U.S. passport help?", a: "Fast Passport Center specializes in U.S. passport services for U.S. citizens. International students at Purdue should contact their home country's embassy or consulate for passport services. We can help Purdue faculty, staff, and U.S. citizen students with American passport needs." },
    { q: "What about Purdue faculty traveling for research or conferences?", a: "We regularly serve Purdue faculty and researchers who need expedited passports for international conferences, research collaborations, and field work. We understand academic travel deadlines and can coordinate expedited services to match your specific schedule." },
    { q: "What airport do Lafayette travelers use?", a: "Indianapolis International Airport (IND) is the primary airport for Lafayette and West Lafayette travelers, located about 70 miles south (approximately 1 hour and 15 minutes via I-65). IND offers direct flights to Toronto, Cancun, and Paris (seasonal), plus connecting service worldwide through major hubs." },
    { q: "How much does an expedited passport cost in Lafayette, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos near Purdue campus?", a: "Walgreens (201 South St, West Lafayette and 3800 State Road 26 E, Lafayette), CVS (102 N Chauncey Ave, West Lafayette), and the UPS Store (multiple locations near campus) all offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Frankfort, Crawfordsville, or Delphi residents?", a: "Absolutely. Fast Passport Center serves all of Tippecanoe County and surrounding areas including Frankfort, Crawfordsville, Delphi, Attica, Dayton, and Battle Ground. Our courier service works the same way for everyone throughout the Wabash Valley region." },
  ],
  photoLocations: [
    { name: "Walgreens — West Lafayette (South St)", address: "201 South St, West Lafayette, IN 47906", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — West Lafayette (Chauncey Ave)", address: "102 N Chauncey Ave, West Lafayette, IN 47906", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — West Lafayette", address: "720 Northwestern Ave, West Lafayette, IN 47906", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Lafayette (State Road 26)", address: "3800 State Road 26 E, Lafayette, IN 47905", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Lafayette", address: "2200 Elmwood Ave, Lafayette, IN 47904", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient Lafayette location near downtown.", featured: true },
    { name: "Indiana BMV — West Lafayette", address: "720 W Navajo St, West Lafayette, IN 47906", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Convenient West Lafayette location near Purdue campus. REAL ID processing available. Good alternative when Lafayette BMV appointments are full.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "70 miles south of Lafayette via I-65 — approximately 1 hour and 15 minutes",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Lafayette, West Lafayette, and Purdue University. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. The main gateway for Purdue international travelers.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "130 miles northwest of Lafayette via I-65 — approximately 2 hours and 15 minutes",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international alternative for Lafayette travelers. Extensive direct flights to Europe, Asia, and Latin America. Often used by Purdue international students and faculty for overseas travel when IND connections are limited.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Tippecanoe County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Tippecanoe County and all Indiana counties" },
    { label: "Tippecanoe County Clerk: Marriage Licenses", url: "https://www.tippecanoe.in.gov/", icon: "ri-heart-line", description: "Tippecanoe County Clerk — marriage license records for Lafayette and Tippecanoe County" },
    { label: "Tippecanoe County: Divorce Decrees", url: "https://www.tippecanoe.in.gov/", icon: "ri-file-list-3-line", description: "Tippecanoe County Clerk of Courts — divorce decree records for Lafayette and Tippecanoe County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Lafayette address" },
  ],
};